import { Controller } from 'stimulus';
import API from '../modules/api';
const api = new API({ authStoreKey: 'techspeclang' });

let loaded = false;

export default class extends Controller {
  static targets = [
    'loader',
    'content',
    'button',
    'select'
  ];

  /**
  * Automatically called when stimulus has initialized controller
  */
  initialize() {
    this.initObserver();
  }

  /**
   * Init intersection observer
   */
  initObserver() {
    const _this = this;
    let observer = new IntersectionObserver(function(entries) {
      if(entries[0].isIntersecting === true && !loaded) {
        _this.getLanguages().then(data => _this.render(data));
        loaded = true;
      }
    }, { threshold: [0] });

    observer.observe(this.buttonTarget);
  }

  /**
   * Get languages and urls from api
   * @returns {array} array of languages with urls
   */
  getLanguages() {
    return api.getTechSpecLanguages({
      type: this.buttonTarget.getAttribute('data-type'),
      slug: this.buttonTarget.getAttribute('data-slug')
    });
  }

  /**
   * Render elements to page
   * @param {array} data array from endpoint
   */
  render(data) {
    if (data?.result?.length > 0) {
      data.result.forEach((item) => {
        let opt = document.createElement('option');
        opt.value = item.url;
        opt.innerHTML = item.language;
        this.selectTarget.appendChild(opt);
      });
      this.buttonTarget.setAttribute('href', data.result[0].url);
    }
    this.loaderTarget.style.display = 'none';
    this.contentTarget.style.opacity = '1';
    this.listeners();
  }

  /**
   * Setup listeners for inputs
   */
  listeners() {
    this.selectTarget.addEventListener('change', (e) => {
      this.buttonTarget.setAttribute('href', e.currentTarget.value);
    });
  }
}
